/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { defineCustomElement } from '@tylertech/forge-core';
import { PopoverComponent } from './popover';
export * from './popover-adapter';
export * from './popover-constants';
export * from './popover-core';
export * from './popover';
export function definePopoverComponent() {
    defineCustomElement(PopoverComponent);
}
